export enum AutocompleteItemBlock {
  Root = 'AutocompleteItem',
}

export enum AutocompleteItemModifier {
  Hoverable = 'hoverable',
  Highlighted = 'highlighted',
}
